module.exports = __webpack_public_path__ + "img/img-3.af85d220.png";